import { useEffect, useState } from 'react';
import './PageLoader.css';

const DEFAULT_STEPS = ['Clients', 'Tasks', 'Compliance', 'Reports'];

// Editorial, left-aligned loading state for a full page's content area (e.g.
// the dashboard while it gathers data). Palette + type come from the design
// tokens. The headline can carry a gold italic accent word via `accent`.
function PageLoader({
  eyebrow = 'Preparing your workspace',
  lead = "Gathering today's ",
  accent = 'filings',
  tail = ', tasks, and client updates',
  sub = 'Pulling deadlines, compliance status, and open items across every client on file.',
  steps = DEFAULT_STEPS,
}) {
  const [activeStep, setActiveStep] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setActiveStep((i) => (i + 1) % steps.length), 1100);
    return () => clearInterval(id);
  }, [steps.length]);

  return (
    <div className="ds-pageloader" role="status" aria-live="polite" aria-label="Loading">
      <div className="ds-pageloader-inner">
        <div className="ds-pageloader-eyebrow">{eyebrow}</div>
        <h1 className="ds-pageloader-title">
          {lead}
          <span className="ds-pageloader-accent">{accent}</span>
          {tail}
          <span className="ds-pageloader-caret" aria-hidden="true" />
        </h1>
        <p className="ds-pageloader-sub">{sub}</p>

        <div className="ds-pageloader-bar-wrap">
          <div className="ds-pageloader-track"><div className="ds-pageloader-fill" /></div>
        </div>

        <div className="ds-pageloader-steps">
          {steps.map((s, i) => (
            <div key={s} className={`ds-pageloader-step${i === activeStep ? ' is-active' : ''}`}>
              <span className="ds-pageloader-dot" />
              {s}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default PageLoader;
